// axiosInstance.js
import axios from 'axios';

const instance = axios.create({
  withCredentials: true,
});

export default instance;


// import axios from 'axios';
// import { config } from './config'; // assuming config is in the same directory

// const instance = axios.create({
//   baseURL: config.apiBaseUrl
// });

// // You can use instance to send requests
// instance.get('/your-endpoint').then(response => {
//   console.log(response.data);
// });


// // Get CSRF token from your server
// instance.get('/csrf-token-endpoint').then(response => {
//   const csrfToken = response.data.csrfToken;

//   // Include CSRF token in the headers for future requests
//   instance.defaults.headers.common['csrf-token'] = csrfToken;

//   // Now you can make other requests and they will include the CSRF token
//   instance.post('/some-other-endpoint', { /* your data here */ });
// });
